module.exports = __webpack_public_path__ + "media/images/img/seikousya/nomura-d4e86d3c78ed190870fbbf46cac52de0.png";